import React, { useContext } from 'react';
import { GeneralData, saveValue, login, logout, resetGeneralData } from '../state/access.slice';
import { IntlContext } from 'react-intl';
import { AccessFormData } from '../beans/access.form.data';
import { AuthManager } from 'src/_shared/managers/auth.manager';
import { FormManager } from 'src/_shared/managers/form.manager';
import { TranslatorManager } from 'src/_shared/managers/TranslatorManager';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { FormHelperUtil } from 'src/_shared/utils/form.helper.util';
import { User } from 'src/api/entities';
import { TextField } from 'src/features/_shared/components/TextField';
import { Button } from 'src/features/_shared/components/Button/button.component';

export const LoginView: React.FC = () => {

    const authManager = AuthManager.getInstance();

    const intl = useContext(IntlContext);
    const getMessageByFieldAndError = FormHelperUtil.getFormFieldErrorTranslator('wizard.general.data', intl as any);

    const generalData: GeneralData = useStoreSelector(state => state.reducer.accessSlice.generalData);
    const loggedUser: User = useStoreSelector(state => state.reducer.accessSlice.loggedUser);



    const handleSubmit = async () => {
        try {
            const isFormValid = await trigger();
            if (isFormValid) {
                const loggedUser = await authManager.login(generalData.email, generalData.password);
                if (loggedUser != null) {
                    store.dispatch(login(loggedUser));
                    store.dispatch(resetGeneralData());
                }
            }
        } catch (error: any) {
            // Qui puoi gestire l'errore, ad esempio:
            if (error.response && error.response.status === 500) {
                // Mostra un messaggio di errore personalizzato
                alert(error.response.data.message || 'Errore di server. Riprova più tardi.');
            } else {
                alert('Errore: ' + (error.message || 'Impossibile effettuare il login.'));
            }
        }
    };

    const handleLogout = async () => {
        await authManager.logout();
        store.dispatch(logout())
    }

    const handleOnBlur = async (key: any, value: string) => {
        console.log('key', key);
        store.dispatch(saveValue({ key, value }));
        await trigger(key as any);
    };

    const { errors, register, trigger, getValues, control, setValue } = FormManager.getInstance().buildFormProxy<AccessFormData>(
        AccessFormData,
        handleSubmit,
        {
            email: generalData.email,
            password: generalData.password,
        },
        'onChange',
    );

    return (
        <div className="d-flex justify-content-center align-items-center vh-100" style={{ minHeight: '100vh' }}>
            <div className="card shadow mx-auto" style={{ minWidth: 400, maxWidth: 500 }}>
                <div className="card-body">
                    <h3 className="card-title text-center mb-4">Login</h3>
                    <div className="mb-3">
                        <label htmlFor="username" className="form-label">Username:</label>
                        <TextField
                            type="text"
                            placeholder={'Email'}
                            id="email"
                            {...register('email', {
                                onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
                                    handleOnBlur(e.target.name, e.target.value);
                                },
                            })}
                            error={errors.country}
                            errorMessage={errors.country && getMessageByFieldAndError('email', errors)}
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="password" className="form-label">Password:</label>
                        <TextField
                            type="password"
                            placeholder={'Password'}
                            id="password"
                            {...register('password', {
                                onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
                                    handleOnBlur(e.target.name, e.target.value);
                                },
                            })}
                            error={errors.password}
                            errorMessage={errors.country && getMessageByFieldAndError('password', errors)}
                        />
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                        <Button identifier="Accedi" onClick={handleSubmit} variant="primary"/>
                    </div>
                    {loggedUser.email !== '' && loggedUser.password !== '' && (
                        <div className="mt-4 text-center">
                            <span style={{ fontSize: 20, fontWeight: 'bold' }}>
                                {`The logged user is "${loggedUser.email}" and his password is "${loggedUser.password}"`}
                            </span>
                            <div className="d-flex justify-content-center mt-3">
                                <Button identifier="access.form.logout" onClick={handleLogout} variant="primary">
                                    Logout
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
